:host {
  background-color: var(--cms-semanticColors-container-medium-background);
  display: block;
  width: 100%;
  margin-bottom: var(--cms-components-mb);  
  --cms-text-color: var(--cms-semanticColors-base-strong-text);
  @include cms-base-font-100;
}

.key-visual-container {
  --cms-grid-padding: var(--cms-spacing-100);
  @include cms-default-grid-container;
}

cms-headline {
  --cms-grid-padding: 0;
}

.grid-item {
  grid-area: var(--cms-default-grid-area);
  position: relative;
  max-height: -moz-fit-content;
  /* Updated to support Firefox */
  max-height: fit-content;
  height: 100%;
}

.cms-key-visual-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: top;
}

.badge-wrapper {
  display: flex;
  margin-bottom: var(--cms-spacing-100);
}

cms-badge {
  justify-content: left;
}

cms-text-button-link {
  margin-bottom: 0;
}

.page-text-box {
  margin-bottom: var(--cms-spacing-100);
}

.keyvisual-text {
  margin-bottom: var(--cms-spacing-075);
  color: var(--cms-text-color);
}

.keyvisual-text p {
  margin-top: 0;
}

.keyvisual-text a {
  color: var(--cms-text-color);
}

.top-image {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left;
  margin-bottom: var(--cms-spacing-100);
  background-image: var(--cms-key-visual-top-image-mobile);
  height: 1.875rem;
}

@supports (selector(:has(*))) {
  .manual-info-box:has(+ :is(cms-text-button-link)) {
    margin-bottom: var(--cms-spacing-100);
  }
}

@include media-width($breakpoint-sm) {
  .grid-item {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .top-image {
    background-image: var(--cms-key-visual-top-image-desktop);
    min-height: 6.25rem;
  }
}